export const CONTACT_INFO = {
  phone: '+216 12 345 678',
  email: 'info@tenjahschool.com',
  address: 'Tunis, Tunisia',
  socialMedia: {
    facebook: '#',
    youtube: '#',
    instagram: '#'
  }
};